import { Component } from '@angular/core';

@Component({
  selector: 'app-configuracoes',
  standalone: false,
  templateUrl: './configuracoes.component.html',
  styleUrl: './configuracoes.component.css'
})
export class ConfiguracoesComponent {
  title = 'Configurações';
  configEmail = false;
  configWhatsapp = false;

  constructor() {
    this.exibirConfiguracoesEmail();
  }


  exibirConfiguracoesEmail() {
    this.title = 'Configurações de email';
    this.configEmail = true;
    this.configWhatsapp = false;
  }

  exibirConfiguracoesWhatsapp() {
    this.title = 'Configurações de email';
    this.configEmail = false;
    this.configWhatsapp = true;
  }
}
